











import {Component, Ref, Vue} from 'vue-property-decorator';
import anime from "animejs"

/**
 * @status stable
 * @published 2.0.0
 * @changelog 2.0.0 Published.
 */
@Component
export default class JdsNavigator extends Vue {

    @Ref() navigatorEl!: HTMLElement;

    // this is more or less just as a ValidationRules right now.
    enter(el: Node, done: ()=>void) {
        anime.timeline({
            easing: 'easeOutExpo',
            complete: done,
        }).add({
            targets: this.navigatorEl.childNodes,
            translateX: [-20, 0],
            scale: [0.9, 1],
            opacity: [0, 1],
            duration: 150,
            delay: anime.stagger(25)
        })
    }
}
